import { Button, FormControl, FormGroup, FormLabel } from "@material-ui/core";
import React from "react";
import { ScrollWrapper } from "../../../helpers/module.helper";

export function ButtonOptionQuestion(props) {
  const { lang, selectOption, question, answerList, questionList, pollTemplate, preview } = props;
  const { questionLanguage, questionId, questionOption } = question;
  const { buttonOption, questionTitle } = pollTemplate;

  const {
    defaultBorderColor,
    defaultTextColor,
    defaultBackgroundColor,
    checkedBorderColor,
    checkedTextColor,
    checkedBackgroundColor,
    borderRadius,
    borderWidth,
    borderStyle,
    fontFamily,
    fontSize,
    fontWeight,
    margin,
  } = buttonOption;

  const checkedStyle = {
    borderColor: checkedBorderColor,
    color: checkedTextColor,
    background: checkedBackgroundColor,
  };

  const defaultStyle = {
    borderColor: defaultBorderColor,
    color: defaultTextColor,
    background: defaultBackgroundColor,
  };

  let buttonStyle = {
    borderRadius,
    borderWidth,
    borderStyle,
    fontFamily,
    fontWeight,
    fontSize,
    minHeight: 20,
    margin: `${margin} 0px`,
    width: "100%",
    height: "auto",
  };

  const label = questionLanguage.find((ql) => ql.languageCode == lang)?.label;

  return (
    <FormControl
      style={{
        width: "100%",
        height: "100%",
      }}
      component="fieldset"
    >
      <FormLabel component="legend" style={{ ...questionTitle }}>
        {label}
      </FormLabel>
      <ScrollWrapper {...props}>
        <FormGroup
          className="jir-scroll"
          style={{
            maxHeight: "100%",
            overflowY: "auto",
            overflowX: "hidden",
            flexDirection: "row",
            paddingBottom: 5,
          }}
        >
          {questionOption.map((o, i) => {
            const selected = answerList.find((al) => al.value == o.questionOptionId && al.questionId == questionId) || (i == 1 && preview);
            buttonStyle = selected ? { ...buttonStyle, ...checkedStyle } : { ...buttonStyle, ...defaultStyle };
            return (
              <Button
                key={i}
                /*    variant={!selected ? "outlined" : "contained"} */
                style={{ ...buttonStyle, textTransform: "none" }}
                disabled={preview}
                onClick={(e) => selectOption(i, !selected ? true : false, questionId)}
              >
                {o.questionOptionLanguage.find((ql) => ql.languageCode == lang)?.label ?? o.questionOptionLanguage[0].label}
              </Button>
            );
          })}
        </FormGroup>
      </ScrollWrapper>
    </FormControl>
  );
}



